import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import JobDatabaseService from "../../../../services/jobDatabase.service";
import { DatabaseCommonTableProps } from "../../../../Types/DatabaseTabTypes";
import styles from "./JobMapView.module.scss";
import { MapConstants } from "../../../../constants/MapConstants";
import { FitBoundsSingle } from "../../../../utils/fitMarkerBounds";

const createCustomIcon = (colorCode) => {
  return L.divIcon({
    className: "custom-marker-icon",
    html: `<div class="naviconmapss" style="color: ${colorCode}; border: 1px solid ${colorCode}; border-radius: 30px; padding: 15px;">
             <i class="fas fa-map-marker"></i>
           </div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });
};

const JobMapView = (props?: DatabaseCommonTableProps) => {
  const { sectionId } = props;
  const { FetchJobDetails } = JobDatabaseService();
  const { 
    GOOGLE_SATILLITE_TILE_LAYER_URL,
    GOOGLE_MAP_ATTRIBUTION,
    GOOGLE_TILE_SUBDOMAIN_ARRAY
  } = MapConstants;
  const { data, refetch, isFetching } = FetchJobDetails(sectionId);

  useEffect(() => {
    refetch();
  }, [sectionId, refetch]);

  if (isFetching || !data || !data?.data) {
    return <div className={styles.mapLoader}>Loading map...</div>;
  }

  const { lat, lng } = data?.data;
  const customMarkerIcon = createCustomIcon("#ff0000");

  return (
    <div className={styles.mapContainer}>
      <MapContainer
        center={[lat, lng]}
        zoom={16}
        className={styles.map}
        zoomSnap={0.15}
        zoomDelta={0.2}
        maxBoundsViscosity={1.0}
        minZoom={2}
      >
        <TileLayer
          attribution={GOOGLE_MAP_ATTRIBUTION}
          url={GOOGLE_SATILLITE_TILE_LAYER_URL}
          subdomains={GOOGLE_TILE_SUBDOMAIN_ARRAY}
        />
        <Marker position={[lat, lng]} icon={customMarkerIcon} />
        <FitBoundsSingle 
          latitude={lat}
          longitude={lng}
        />
      </MapContainer>
    </div>
  );
};

export default JobMapView;
